import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/enums/api-status';
import { loginAsync, refreshTokenAsync, fetchCollaboratorNDAStatusAsync } from './authThunk';
import { getCurrentUserFromJwt } from '@application/helpers/jwt-helper';
import LocalStorageService from '@application/common/local-storage-service';
const initialState = {
    status: APIStatus.IDLE,
    currentUser: getCurrentUserFromJwt(),
    permissions: [],
    isPreviewMode: false,
    previewRoleLabel: undefined,
    originalCurrentUser: undefined,
};
export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        logout(state) {
            state.currentUser = undefined;
            state.permissions = [];
            state.isPreviewMode = false;
            state.previewRoleLabel = undefined;
            state.originalCurrentUser = undefined;
            LocalStorageService.removeAccessToken();
            LocalStorageService.removeMSAccessToken();
            LocalStorageService.removeSignalRToken();
            LocalStorageService.removeSelectedCompanyIdForTab();
            state.apiError = undefined;
            state.status = APIStatus.IDLE;
            state.currentUser = undefined;
        },
        logoutApplicationOnly(state) {
            state.currentUser = undefined;
            state.permissions = [];
            state.isPreviewMode = false;
            state.previewRoleLabel = undefined;
            state.originalCurrentUser = undefined;
            LocalStorageService.removeAccessToken();
            LocalStorageService.removeSignalRToken();
            LocalStorageService.removeSelectedCompanyIdForTab();
            state.apiError = undefined;
            state.status = APIStatus.IDLE;
            state.currentUser = undefined;
        },
        resetAuthApiState(state) {
            state.status = APIStatus.IDLE;
        },
        initializeAuthFromToken(state) {
            const accessToken = LocalStorageService.getAccessToken();
            if (accessToken && !state.currentUser) {
                state.currentUser = getCurrentUserFromJwt(accessToken);
            }
        },
        updateNDASignedStatus(state, action) {
            if (state.currentUser) {
                state.currentUser.isNDASigned = action.payload;
            }
        },
        startRolePreview(state, action) {
            const option = action.payload;
            state.originalCurrentUser = state.currentUser;
            state.isPreviewMode = true;
            state.previewRoleLabel = option.label;
            if (state.currentUser) {
                state.currentUser = {
                    ...state.currentUser,
                    role: option.role,
                    permissions: option.permissions,
                    IsCollaborator: option.IsCollaborator ?? false,
                    CollaboratorAccessLevel: option.CollaboratorAccessLevel ?? undefined,
                };
            }
        },
        stopRolePreview(state) {
            if (state.originalCurrentUser) {
                state.currentUser = state.originalCurrentUser;
            }
            state.isPreviewMode = false;
            state.previewRoleLabel = undefined;
            state.originalCurrentUser = undefined;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(loginAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(loginAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.currentUser = getCurrentUserFromJwt(action.payload.accessToken);
            LocalStorageService.setAccessToken(action.payload.accessToken);
            if (action.payload.signalRToken) {
                LocalStorageService.setSignalRToken(action.payload.signalRToken);
            }
            state.permissions = action.payload.permissions || [];
        })
            .addCase(loginAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
            state.permissions = [];
        })
            .addCase(refreshTokenAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.currentUser = getCurrentUserFromJwt(action.payload.accessToken);
            LocalStorageService.setAccessToken(action.payload.accessToken);
            if (action.payload.permissions) {
                state.permissions = action.payload.permissions;
            }
            state.apiError = undefined;
        })
            .addCase(refreshTokenAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
            state.permissions = [];
        })
            .addCase(fetchCollaboratorNDAStatusAsync.fulfilled, (state, action) => {
            if (state.currentUser) {
                state.currentUser.isNDASigned = action.payload;
            }
        });
    }
});
export const { logout, logoutApplicationOnly, resetAuthApiState, initializeAuthFromToken, updateNDASignedStatus, startRolePreview, stopRolePreview, } = authSlice.actions;
export default authSlice.reducer;
